
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.914 9.094c-.219.776-.64 1.456-1.266 2.039l-.664-.688c.412-.411.709-.862.891-1.351H.531l-.39-.672 3.593-4.313a4.708 4.708 0 00-1.257-.148c-.25 0-.482.016-.696.047l-.125-.914c.266-.042.555-.063.867-.063.672 0 1.287.091 1.844.274l2.492-3 .914.758-2.335 2.773a3.78 3.78 0 011.32 1.562c.286.63.43 1.357.43 2.18 0 .031-.003.107-.008.227-.006.12-.008.187-.008.203h2.312v1.086h-2.57zM4.781 4.617L1.93 8.007h4.203c.01-.109.015-.228.015-.359 0-.671-.117-1.263-.351-1.773A3.046 3.046 0 004.78 4.617z","fill":"currentColor"}})])
          )
        }
      }
    